import { Card as AntCard, List } from 'antd'
import styled from 'styled-components'

import { Text } from 'src/components/Ant'

export const AdditionalInfo = styled.div`
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
`

export const AgencyInfo = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px;
  > :last-child {
    align-self: center;
    text-align: right;
    vertical-align: bottom;
  }
`

export const Card = styled(AntCard)`
  margin-bottom: 16px;
`

export const CardContentDiv = styled.div`
  padding: 12px;
`

export const CardTopDiv = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 4px;
  > div {
    align-self: center;
    vertical-align: middle;
  }
`

export const Code = styled.div`
  padding-bottom: 4px;
  > span {
    font-size: 20px;
    margin-bottom: 12px;
    .anticon-copy {
      font-size: 12px;
      margin-right: 4px;
    }
  }
`

export const DivBordered = styled.div`
  border-bottom: 1px solid #e8e8e8;
`

export const IconWhatsApp = styled.img`
  height: 20px;
  width: 20px;
  margin-left: 5px;
  cursor: pointer;
`

export const Image = styled.div<{ align?: string }>`
  display: flex;
  justify-content: ${({ align }) => align || 'inherit'};
`

export const TextEllipsis = styled.div`
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const Title = styled(Text)`
  color: rgba(0, 0, 0, 0.85);
  font-size: 20px;
  font-weight: 600;
  line-height: 1.4;
`

export const VehicleItem = styled(List.Item)`
  border: 1px solid #e8e8e8;
  margin: 24px 0;
  padding: 0;
`
